export const CHAPTER1 = {
  firstScene: 'gatesOfAsgard',
  scenes: {
    'gatesOfAsgard': {
      id: 'gatesOfAsgard',
      locationId: 'nineRealms',
      characters: {
        left: {
          entering: true,
          speakerId: 'astridStormweaver'
        },
        right: {
          entering: true,
          speakerId: 'sindriStarforge'
        }
      },
      lines: [
        {
          type: 'dialog',
          name: 'Astrid Stormweaver',
          speakerId: 'astridStormweaver',
          text: "The gates of Asgard stand before us. The trials ahead will test not just our strength, but our wisdom.",
        },
        {
          type: 'dialog',
          name: 'Sindri Starforge',
          speakerId: 'sindriStarforge',
          text: "The ancient trials were designed by Odin himself. Many have failed, but I believe in your potential.",
          choices: [
            {
              text: 'Begin the trials',
              nextScene: 'acceptTrials'
            },
            {
              text: 'Ask about previous challengers',
              nextScene: 'previousChallengers'
            }
          ]
        }
      ],
      barFill: 60,
      barName: "Divine Power",
      timeName: "Asgardian Time"
    },
    'acceptTrials': {
      id: 'acceptTrials',
      locationId: 'nineRealms',
      characters: {
        left: {
          entering: false,
          speakerId: 'astridStormweaver'
        },
        right: {
          entering: false,
          speakerId: 'sindriStarforge'
        }
      },
      lines: [
        {
          type: 'dialog',
          name: 'Astrid Stormweaver',
          speakerId: 'astridStormweaver',
          text: "I accept these trials with honor. May the All-Father guide our path.",
          choices: [
            {
              text: 'Proceed to the trials',
              exitScene: true
            }
          ]
        }
      ],
      barFill: 65,
      barName: "Divine Power",
      timeName: "Asgardian Time"
    },
    'previousChallengers': {
      id: 'previousChallengers',
      locationId: 'nineRealms',
      characters: {
        left: {
          entering: false,
          speakerId: 'astridStormweaver'
        },
        right: {
          entering: false,
          speakerId: 'sindriStarforge'
        }
      },
      lines: [
        {
          type: 'dialog',
          name: 'Sindri Starforge',
          speakerId: 'sindriStarforge',
          text: "Many great warriors have attempted these trials. Some became legends, others were never seen again. The choices you make here will echo through eternity.",
          choices: [
            {
              text: 'Begin the trials',
              nextScene: 'acceptTrials'
            }
          ]
        }
      ],
      barFill: 65,
      barName: "Divine Power",
      timeName: "Asgardian Time"
    }
  }
};